import { atomWithDefault } from 'jotai/utils';

import { userInfoAtom } from '~atoms';
import { UserRoleEnum } from '~enums';
import { Organisation } from '~features/organisations';
import { User } from '~features/users';

/**
 * An atom for a shared filter state
 */
const selectedOrganisationAtom = atomWithDefault<Promise<Organisation> | Organisation>(
	async (get) => {
		try {
			const userInfo = (await get(userInfoAtom)) as User;
			if (userInfo?.role?.toLowerCase() === UserRoleEnum.Admin) {
				return userInfo?.organisation;
			}
			return null;
		} catch (error) {
			console.warn(error);
			return null;
		}
	}
);

export default selectedOrganisationAtom;
